 
import icon16 from "../images/mentors/Harsh.jpg" 
const icon12 ="https://www.winpeforum.com/assets/elements/NruthyaMadappa.jpg";
const icon17 ="https://www.winpeforum.com/assets/elements/SakshiChopra.png";
const icon18 ="https://www.winpeforum.com/assets/elements/PratibhaJain.png";
 
const icon21 = "https://www.winpeforum.com/assets/elements/KanwaljitSingh.png";
  
const icon28 = "https://www.winpeforum.com/assets/elements/Pallavi.png";
const icon29 = "https://www.winpeforum.com/assets/elements/ShivaniBhasin.png";
const icon30 = "https://www.winpeforum.com/assets/elements/VTBharadwaj.png";
const icon31 = "https://www.winpeforum.com/assets/elements/AnshikaMalaviya.png";
const icon32 = "https://www.winpeforum.com/assets/elements/SujoyBose.png";
const icon7 = "https://www.winpeforum.com/assets/elements/SimrunMehta.png";

const mentors_constants = [
    {
        imgUrl: icon31,
        into:" "
        ,
        name:"Anshika Malaviya",
        post:"Investment Officer, Asia",
        cmp:"International Finance Corporation",
        link:"https://www.linkedin.com/in/anshikamalaviya/" 
         
    },
  {
        imgUrl: icon16,
        into:" ",
        desc: `Accomplished business leader with expertise in Emerging Markets investing, building highly profitable investment businesses from the scratch, and setting and growing up multiple investment platforms.
<br/><br/>
Spotted trends early on and used this to build large investments through the platform, in a manner that assets are well diversified to optimize returns.
<br/><br/>
Early investor in Sustainability for 15 years, built platforms, and invested in global technology businesses. During his career he has worked on financial investments across products and industries; advised CEOs on businesses and financial strategy, and built teams.
<br/><br/>
Key career highlights include building IFC’s renewable investing business, conceptualizing and building India’s largest road platform and setting up CDPQ India business across public equity, private equity, infra and fixed income.
<br/><br/>
Through these journeys he has gained rich experience in scaling up businesses, driving sustainability, and corporate governance. Leading large global projects in multi-country and cultural settings. Negotiating documents under international tax and corporate laws. Building value creation strategies, executing these and steering organizational change.`,
        name:"Harsh Singhal",
        post:"Partner",
        cmp:"ProsperETE",
        link:"https://www.linkedin.com/in/harsh-singhal-8321844/?originalSubdomain=in",
         
    },
    
    {
        imgUrl: icon21,
        into:"Kanwal has always been passionate about mentoring and helping build consumer brands in India",
        desc: `Kanwal has always been passionate about mentoring and helping build consumer brands in India, and has been involved as an investor with brands like Paper Boat, ID Fresh, Epigamia, and Licious, before starting Fireside. He has been investing in the early stage ecosystem in India for the past 17 years, first as a Director at Carlyle Group, India, and later as a Co-Founder and Senior Managing Director of Helion Venture Partners. Prior to his investing career, Kanwal spent over 13 years in consumer marketing with Hindustan Unilever, and Intel India.
        `,
        name:"Kanwaljit Singh",
        post:"Managing Partner",
        cmp:"Fireside Ventures",
        link:"https://in.linkedin.com/in/singhkanwaljit" 
    },
    


  {
            imgUrl: icon12,
            into:"  ",
            desc: `Nruthya Madappa is Partner at 3one4 Capital. In addition to supporting investments, topline and capital growth for the portfolio at the firm, Nruthya works closely with global institutional and strategic investors to drive the growth of our portfolio companies. Her team partners deeply with the latter in planning and achieving financial and strategic objectives including capital raises, revenue acceleration, M&A, and exits.
<br/><br/>
Over her career in the US and India, Nruthya has led global teams across technology, finance, real estate, education and economic policy. Before 3one4 Capital, Nruthya founded and led The CoWrks Foundry (a business accelerator for early stage companies) as Managing Partner, investing in over 25 companies and establishing global partnerships with Yale and Columbia University.
<br/><br/>
Prior to The CoWrks Foundry she drove the Revenue and Growth orgs at Cuemath and spearheaded the 15M Series B from Capital G and Sequoia Capital for the edtech giant. Throughout her career, Nruthya has designed and scaled products, and raised capital for high growth companies - strengths she brings to bear for the 3one4 portfolio.
<br/><br/>
Nruthya holds BS and MS degrees in Electrical Engineering from Stanford University and an MBA from Harvard Business School.

            
           </div>`,
            name:"Nruthya Madappa",
            post:"Partner",
            cmp:"3one4 Capital",
            link:"https://www.linkedin.com/in/nruthya/" 
        },


    {
        imgUrl: icon28,
        into:"Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group",
        desc: `Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group.

Pallavi’s practice focuses on debt and equity capital markets transactions in India and across the Asia Pacific region where she has nearly 20 years of experience advising issuers, underwriters and sponsors on Rule 144A and Regulation S international debt offerings, IPOs and private placements and equity linked offerings of exchangeable and convertible bonds.

Pallavi also has significant experience in bond restructurings, consent solicitations, exchange offers, induced conversions and tender offers. Many of the transactions she has advised on have been complex, innovative and award-winning.

Pallavi is qualified as a solicitor in India, England and Wales and Singapore.

Pallavi is consistently ranked in leading benchmarking publications. Chambers Asia Pacific 2021 said “Pallavi has extensive experience in India, is technically superior and pragmatic, and has a great temperament.” Clients were quoted in Chambers Asia Pacific 2023 as saying “Pallavi is extremely knowledgeable about India and provides solutions to complex issues.” and that she is “very commercial, very client-focused with issuers and underwriters. She is excellent.”
.
        `,
        name:"Pallavi Gopinath Aney",
        post:"Partner",
        cmp:"Allen & Overy",
        link:"https://www.linkedin.com/in/pallavi-gopinath-aney-5922292/",
         
    },

    { imgUrl: icon18,
        name: "Pratibha Jain",
         desc: `Pratibha Jain is the Head of Strategy, Group General Counsel, and a member of the Management Committee at Everstone. She leads the Group’s legal and strategic functions, bringing over two decades of international and Indian experience. Prior to joining Everstone, she was a Partner at Nishith Desai Associates, where she founded the New Delhi office and led the Funds and Regulatory practice. Her career spans roles at Sullivan & Cromwell in New York, Tokyo, and Hong Kong; Skadden, Arps, Slate, Meagher & Flom LLP in Hong Kong; and Goldman Sachs in Hong Kong and Mumbai. Pratibha holds a Master of Laws from Harvard University, a Bachelor of Civil Laws from the University of Oxford, and a Bachelor of Laws from the University of Delhi. She also chairs the Regulatory Committee of IVCA and serves as Co-Head of the American Bar Association’s India Committee. 

`,
         post: "Group General Counsel & Head of Strategy",
        cmp: "Everstone Group",
        linkedIn: "https://www.linkedin.com/in/pratibha-jain-35210059/"
      },
      { imgUrl: icon17,
        name: "Sakshi Chopra",
         desc: `Sakshi Chopra is Managing Director at Peak XV Partners. She began her career in banking in Germany and returned to India in 2010, driven by a strong conviction in India’s long-term growth and entrepreneurial opportunity.
At Peak XV, Sakshi partners with founders across multiple market cycles and startup stages. She focuses on backing ambitious teams building category-defining companies, with an emphasis on strong culture, long-term execution, and large-scale problem solving. Her investment approach is shaped by deep exposure to varied founder journeys, spanning rapid growth, operational challenges, and sustained value creation.
`,
         post: "Managing Director\n",
        cmp: "Peak XV Partners",
        linkedIn: "https://www.linkedin.com/in/sakshi-chopra-4aa1881/"
      },
      {
        imgUrl: icon7,
        into:"Simrun Mehta",
        desc: ` Simrun Mehta (Mumbai) joined KKR in 2012 and is a Managing Director on the Private Equity team. Ms. Mehta has been closely involved in KKR’s investments across sectors, and currently serves on the Boards of Vini Cosmetics, Lighthouse Learning, Avendus Capital, RE Sustainability and Ness Digital Engineering. Prior to joining KKR, Ms. Mehta worked with Nomura's fixed income team and the commodities division of Lehman Brothers. 
<br/><br/>
Ms. Mehta holds a Bachelor of Arts (Honours) in Mathematics from St. Stephen's College, University of Delhi. 



        `,
        name:"Simrun Mehta",
        post:"Managing Director",
        cmp:"KKR & Co. Inc.",
        link:"https://www.linkedin.com/in/simrun-mehta-06909348/",
         
    },
   
    {
        imgUrl: icon29,
        into:"Shivani Bhasin Sachdeva",
        desc: ` Shivani Bhasin Sachdeva is the Founder and Chief Executive Officer at India Alternatives. Shivani has over 15 years of private equity experience in the USA and in India at top notch private equity funds including IDFC Private Equity, Lightyear Capital and GE Equity where she has been responsible for deal sourcing, execution and monitoring companies across various sectors. Shivani has helped shape strategy at various companies through board level involvement and been instrumental in generating superior returns for her investors. Shivani is an MBA from Wharton and a BA from Mount Holyoke College (Massachusetts).

        `,
        name:"Shivani Bhasin Sachdeva",
        post:" Founder & CEO",
        cmp:"India Alternatives",
        link:"https://in.linkedin.com/in/shivani-bhasin-sachdeva-47234757",
         
    },
 
     
    {
        imgUrl: icon32,
         
        desc: `Sujoy Bose is the CEO – Investment Management, spearheading capital formation, deal sourcing, fund governance, and ESG & impact initiatives. He manages capital raising efforts, strengthening relationships with Limited Partners (LPs), and enhancing the firm’s deal flow across various sectors. Sujoy brings to the firm over 30 years of experience in fund management, infrastructure investment, and strategic leadership. He previously led India’s National Investment and Infrastructure Fund (NIIF) as Managing Director and CEO, overseeing its growth into a leading investment and infrastructure management entity in just seven years. Prior to NIIF, he spent 23 years at the International Finance Corporation (IFC), where he held pivotal roles such as Global Co-Head of Infrastructure and Natural Resources and Chief Investment Officer of IFC Asset Management. Sujoy started his career with Citibank in India. He holds an MBA from Rice University, Houston, and a B.Com from St. Xavier’s College, Kolkata.

        `,
        name:"Sujoy Bose",
        post:"CEO, Investment Management",
        cmp:"Everstone",
        link:"https://www.linkedin.com/in/sujoy-bose-ab675224/" 
    },
    
    
    {
        imgUrl: icon30,
        into:"VT Bharadwaj is a co-founder and General Partner at A91 Partners",
        desc: `VT Bharadwaj is a General Partner at A91 Partners, an Indian private investment firm that seeks to partner with founders to build enduring businesses for tomorrow’s India.<br/><br/>
 
        Prior to co-founding A91 Partners, VT was a Managing Director at Sequoia Capital, a global venture capital firm in India where he led investments in consumer, pharmaceutical and healthcare sectors. Prior to that he worked at McKinsey & Co.<br/><br/>
         
        VT has an MBA from Indian Institute of Management Ahmedabad and a BE (Hons) in Electrical and Electronics Engineering from BITS Pilani
        <br/><br/>
        VT is a trustee at Ashoka University, a board member of IIM Ahmedabad Endowment Management Company, a Founding Circle member of Museum of Art & Photography and involved with Cuddles Foundation and Swasth Foundation.
        `,
        name:"VT Bharadwaj",
        post:"Co-founder and General Partner",
        cmp:"A91 Partners",
        link:"https://in.linkedin.com/in/vt-bharadwaj-2333ba1" 
    },
    
    
    
   
     
]


 
export default mentors_constants 


// WEBPACK FOOTER //
// ./src/constant/mentors5.js